import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/es/styles/withStyles';
import { getAccountPII } from '../delete-account/DeleteAccountActions';
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import Axios from 'axios';
const styles = theme => ({
    a: {
        color: "#1F6BF1 !important"
    }
});

class Subscription extends Component {

        constructor(props) {
            super(props);
            this.state = { hasSubscription: false, fetchFinish: false };
        }

        componentWillMount() {
            const { user  } = this.props;     
        }

        componentDidMount() {
            
            const { user } = this.props; 
            
            const checkSubscrption = Axios.get('https://api.stripe.com/v1/customers', {headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer sk_test_51Mb1HVLeRHgXm1nry4x4vtd6kJ1mqCqBHPZcX9mohuecvE8N7mJQNbrWETsMf9evIFp3cMKv9jRL3TdBW052MeFs00k0JqwjJn'
            }})
            .then(function(response) {
                return response
            })
            .catch(
                err => console.log(err)
            );

            const getData = async () => {
                const allData = await checkSubscrption;
                if(allData.data.data.find(o => o.email === user.email)) {
                    console.log('res contain')
                    this.setState({ hasSubscription: true })
                    this.setState({ fetchFinish: true })
                } else {
                    console.log('no res')
                    this.setState({ hasSubscription: false })
                    this.setState({ fetchFinish: true })
                }
            };

            getData();
        }

        componentWillUnmount() {
            // fix Warning: Can't perform a React state update on an unmounted component
            this.setState = (state,callback)=>{
                return;
            };
        }

        render() {
            
            const userEmail = this.props.user.email;
            console.log(this.state.hasSubscription)
            
            return (
                <div id='subscription'>
                    {!this.state.fetchFinish && <div>
                        <p>Loading...</p>
                    </div>}
                    {this.state.fetchFinish && <div>
                        {this.state.hasSubscription && <div>You are subscribed with a {userEmail} account <br />
                            <a href='https://checkout.bluemail.me/p/login/3cs3dt1Ux4gP3PqcMM' target= '_blank' ><span style={{color: '#1F6BF1'}}>Manage Subscription</span></a>
                         </div>} 
                        {!this.state.hasSubscription && <div>Not subscribed <br />
                            <a href='https://checkout.bluemail.me/p/login/3cs3dt1Ux4gP3PqcMM' target= '_blank' ><span style={{color: '#1F6BF1'}}>Manage Subscription</span></a>
                        </div>} 
                    </div>}
                    <br />
                    <div>
                    If you subscribed through the <span style={{fontWeight: '700'}}>App Store</span>: <br />
                    Please see <a href='https://support.apple.com/en-us/HT202039' target='_blank' ><span style={{color: '#1F6BF1'}}>How to cancel a subscription from Apple</span></a>
                    </div>
                    <br />
                    <div>
                    If you subscribed through <span style={{fontWeight: '700'}}>Google Play</span>: <br />
                    Please see <a href='https://support.google.com/googleplay/answer/7018481' target='_blank' ><span style={{color: '#1F6BF1'}}>How to cancel a subscription from Google Play</span></a>
                    </div>
                </div>
            );
        }
    }

    function mapStateToProps({ user }) {
        return { user };
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators(
            {
            getAccountPII,
            },
            dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Subscription));



// WEBPACK FOOTER //
// ./src/containers/subscription/Subscription.js